// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import React from 'react';
import { QuickTableReactViewModel } from '../../ViewModels/QuickTableReactViewModel';
export class QuickTableReact extends WMComponent {
    constructor(props, viewModel) {
        super(props, viewModel !== null && viewModel !== void 0 ? viewModel : QuickTableReactViewModel);
        this.resizeObserver = null;
        this.onResize = this.onResize.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseWheel = this.onMouseWheel.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onDoubleClick = this.onDoubleClick.bind(this);
        this.refWrappperContainer = React.createRef();
        this.refCanvas = React.createRef();
    }
    componentDidMount() {
        super.componentDidMount();
        const canvas = this.refCanvas.current;
        const ctx = canvas.getContext('2d', { alpha: false });
        this.viewModel.createQuickTable(ctx);
        this.setSizes();
        if (this.refWrappperContainer.current) {
            this.resizeObserver = new ResizeObserver(() => {
                this.onResize();
            });
            this.resizeObserver.observe(this.refWrappperContainer.current);
        }
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
    onResize() {
        this.viewModel.resetSizes();
        this.setSizes();
    }
    onMouseDown(event) {
        this.viewModel.onMouseDown(event);
    }
    onMouseMove(event) {
        this.viewModel.onMouseMove(event);
    }
    onMouseLeave(event) {
        this.viewModel.onMouseLeave(event);
    }
    onMouseUp(event) {
        this.viewModel.onMouseUp(event);
    }
    onMouseWheel(event) {
        this.viewModel.onMouseWheel(event);
    }
    onClick(event) {
        this.viewModel.onClick(event);
    }
    onDoubleClick(event) {
        this.viewModel.onDoubleClick(event);
    }
    setSizes() {
        const panel = this.refWrappperContainer.current;
        const w = panel.offsetWidth;
        const h = panel.offsetHeight;
        this.viewModel.setSizes(w, h);
        const devicePixelRatio = window.devicePixelRatio || 1;
        const canvas = this.refCanvas.current;
        canvas.width = w * devicePixelRatio;
        canvas.height = h * devicePixelRatio;
        this.viewModel.setContextScale(devicePixelRatio);
    }
    render(style) {
        const { enabled, additionalClass } = this.props;
        return (React.createElement("div", { className: `quickTableOuter ${additionalClass}${!enabled ? ' disabled' : ''}`, ref: this.refWrappperContainer, style: style }, this.renderCanvas()));
    }
    renderCanvas() {
        const { tableBackColor, currentCursor } = this.state;
        return (React.createElement("canvas", { ref: this.refCanvas, style: {
                backgroundColor: tableBackColor,
                cursor: currentCursor
            }, onMouseDown: this.onMouseDown, onMouseMove: this.onMouseMove, onMouseLeave: this.onMouseLeave, onMouseUp: this.onMouseUp, onWheel: this.onMouseWheel, onClick: this.onClick, onDoubleClick: this.onDoubleClick }));
    }
}
QuickTableReact.defaultProps = {
    isAttached: true
};
